export default __webpack_public_path__ + "static/media/62.9e4984cd.png";